const SELECTED_PATIENT_STORAGE_KEY = "selectedPatientProfile";

function canUseSessionStorage() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function readStoredSelectedPatient() {
  if (!canUseSessionStorage()) {
    return null;
  }

  try {
    const rawValue = window.sessionStorage.getItem(SELECTED_PATIENT_STORAGE_KEY);

    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);

    if (!parsedValue || typeof parsedValue !== "object") {
      return null;
    }

    return parsedValue;
  } catch (error) {
    return null;
  }
}

export function writeStoredSelectedPatient(patient) {
  if (!canUseSessionStorage()) {
    return;
  }

  if (!patient || (!patient.sid && !patient.uid)) {
    window.sessionStorage.removeItem(SELECTED_PATIENT_STORAGE_KEY);
    return;
  }

  const safePatient = {
    sid: patient.sid || null,
    uid: patient.uid || null,
    uids: Array.isArray(patient.uids) ? patient.uids : [],
    email: patient.email || null,
    emails: Array.isArray(patient.emails) ? patient.emails : [],
    measurementsCount:
      typeof patient.measurementsCount === "number"
        ? patient.measurementsCount
        : null,
    lastMeasurementAt: patient.lastMeasurementAt || null,
  };

  window.sessionStorage.setItem(
    SELECTED_PATIENT_STORAGE_KEY,
    JSON.stringify(safePatient),
  );
}

export function clearStoredSelectedPatient() {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(SELECTED_PATIENT_STORAGE_KEY);
}

export function buildPatientProfileHref(patient) {
  const sid = typeof patient?.sid === "string" ? patient.sid.trim() : "";

  if (sid && sid.toUpperCase() !== "N/A") {
    return `/patients/profile?sid=${encodeURIComponent(sid)}`;
  }

  return "/patients/profile";
}
